import { useEffect } from 'react';
import { track } from '../analytics';

/**
 * One `screen_viewed` for every page and every step inside one, so any
 * funnel in PostHog is one event broken down by `page` and `screen`, and
 * the last row somebody has is the place they stopped (owner, 2026-10-29:
 * "make sure every page now has analytics"). Pageviews are off
 * (analytics.ts), and the older per-flow events (`intro_step`,
 * `imagine_level`…) stay as they were, so history still reads.
 *
 * `page` is the screen component, never a url (codes and post ids stay
 * out); `screen` the step within it, the page itself when it has none.
 * Sent again only when one of them, or a prop, changes.
 */
export function useViewed(page: string, screen: string = page, props: Record<string, string | number | boolean | undefined> = {}) {
  const extra = JSON.stringify(props);
  useEffect(() => {
    track('screen_viewed', { page, screen, ...(JSON.parse(extra) as Record<string, unknown>) });
  }, [page, screen, extra]);
}
